(function ($) {
  var photoCommentScriptObj = localizedData.photoCommentScript;

  $(document).ready(function () {
    function triggerInitialClick(targetNpId, targetPcId, targetRowIndex) {
      setTimeout(function () {
        // Find the first .gallery-photo-comment element that meets the criteria and is not within a .slick-cloned element
        var $originalElements = $(".gallery-photo-comment").filter(function () {
          var species_id = $(this).attr("data-species-id");
          var pc_id = $(this).attr("data-pc-id");
          var data_row_index = $(this).attr("data-row-index");
          localStorage.removeItem("triggerInitialClickNp");
          localStorage.removeItem("triggerInitialClickPc");
          localStorage.removeItem("triggerInitialClickRow");

          return (
            $(this).closest(".slick-cloned").length === 0 &&
            species_id == targetNpId &&
            pc_id == targetPcId &&
            data_row_index == targetRowIndex
          );
        });

        if ($originalElements.length > 0) {
          // Trigger click on the first original element that meets the criteria
          $originalElements.first().trigger("click");
        }
      }, 1000); // Adjust the delay (in milliseconds) as needed
    }

    if (localStorage.getItem("triggerInitialClick") === "true") {
      var species_id = localStorage.getItem("triggerInitialClickNp");
      var pc_id = localStorage.getItem("triggerInitialClickPc");
      var row_index = localStorage.getItem("triggerInitialClickRow");
      localStorage.removeItem("triggerInitialClick");
      triggerInitialClick(species_id, pc_id, row_index);
    }
  });

  // For showing photo with comment popup.
  $(document).on("click", ".gallery-photo-comment", function (e) {
    e.preventDefault();
    var species_id = $(this).attr("data-species-id");
    var pc_id = $(this).attr("data-pc-id");
    var data_row_index = $(this).attr("data-row-index");
    $.ajax({
      url: photoCommentScriptObj.ajax_url,
      type: "POST",

      data: {
        action: "photo_comment_popup",
        species_id: species_id,
        pc_id: pc_id,
        data_row_index: data_row_index,
        nonce: photoCommentScriptObj.photo_comment_popup_nonce,
      },
      success: function (response) {
        let htmlresponse = response.data.html;
        if (htmlresponse) {
          $("main").append(htmlresponse);
        }
      },
      error: function (xhr, status, error) {},
    });
  });

  // Handle like button clicks in dynamic content
  $(document).on("click", ".like-button", function (e) {
    e.preventDefault();
    var button = $(this);
    var pc_id = button.attr("data-pc-id");
    var row_index = button.attr("data-row-index");

    $.ajax({
      url: photoCommentScriptObj.ajax_url,
      type: "POST",
      data: {
        action: "toggle_image_like",
        pc_id: pc_id,
        data_row_index: row_index,
        nonce: photoCommentScriptObj.toggle_image_like_nonce,
      },
      success: function (response) {
        if (response.success) {
          // button.find(".like-count").text(response.data.likes_count);
          let action = response.data.action;
          let likeCount = response.data.like_count;

          // Update the button appearance and like count.
          button.toggleClass("liked", action === "liked");
          button.find(".like-count").text(likeCount);
        }
      },
      error: function (xhr, status, error) {
        console.log("Error:", error);
      },
    });
  });

  // $("#add-photo-comment-form").validate({
  $(document).on("ajaxComplete", function () {
    $("#add-photo-comment-form").validate({
      rules: {
        comment: {
          required: true,
          maxlength: 250,
        },
      },
      messages: {
        comment: {
          required: "Cannot be empty.",
          maxlength: "Comment cannot be more than 250 characters.",
        },
      },
      submitHandler: function (form) {
        var formData = new FormData(form);
        formData.append("action", "insert_photo_comment");
        formData.append(
          "nonce",
          photoCommentScriptObj.insert_photo_comment_nonce
        );
        $.ajax({
          url: photoCommentScriptObj.ajax_url,
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            var species_id = response.data.species_id;
            var pc_id = response.data.pc_id;
            var data_row_index = response.data.data_row_index;
            localStorage.setItem("triggerInitialClick", "true");
            localStorage.setItem("triggerInitialClickPc", pc_id);
            localStorage.setItem("triggerInitialClickNp", species_id);
            localStorage.setItem("triggerInitialClickRow", data_row_index);
            // Reload the page
            location.reload();
            // window.location.replace(window.location.href);
          },
          error: function (xhr, status, error) {},
        });
      },
    });

    $("#edit-photo-comment-form").validate({
      rules: {
        comment: {
          required: true,
          maxlength: 250,
        },
      },
      messages: {
        comment: {
          required: "Cannot be empty.",
          maxlength: "Comment cannot be more than 250 characters.",
        },
      },
      submitHandler: function (form) {
        var formData = new FormData(form);
        formData.append("action", "insert_photo_comment");
        formData.append(
          "nonce",
          photoCommentScriptObj.insert_photo_comment_nonce
        );
        $.ajax({
          url: photoCommentScriptObj.ajax_url,
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            var species_id = response.data.species_id;
            var pc_id = response.data.pc_id;
            var data_row_index = response.data.data_row_index;
            localStorage.setItem("triggerInitialClick", "true");
            localStorage.setItem("triggerInitialClickPc", pc_id);
            localStorage.setItem("triggerInitialClickNp", species_id);
            localStorage.setItem("triggerInitialClickRow", data_row_index);
            // Reload the page
            location.reload();
          },
          error: function (xhr, status, error) {},
        });
      },
    });
  });

  // For showing and setting data for the edit comment in the photo.
  $(document).on("click", ".edit_photo_comment", function () {
    var eachComment = $(this).closest(".each-comment");
    var commentText = eachComment
      .find(".comment-bottom .comment")
      .text()
      .trim();

    var comment_edit_popup = $("#comment-edit-popup");
    var pc_id = eachComment.data("pc-id");
    var row_index = eachComment.data("row-index");
    var comment_index = eachComment.data("comment-index");

    comment_edit_popup.show();
    comment_edit_popup.find('input[name="comment"]').val(commentText);
    comment_edit_popup.find('input[name="pc_id"]').val(pc_id);
    comment_edit_popup.find('input[name="data_row_index"]').val(row_index);
    comment_edit_popup.find('input[name="comment_index"]').val(comment_index);
  });

  // For showing deleting comment in the photo.
  $(document).on("click", ".delete_photo_comment", function () {
    // Get the nearest parent element with the class .each-comment
    var eachComment = $(this).closest(".each-comment");

    // Now you have the eachComment element, you can perform any action you need
    var pc_id = eachComment.data("pc-id");
    var row_index = eachComment.data("row-index");
    var comment_index = eachComment.data("comment-index");
    var confirmMssg = "Do you really want to delete?";
    if (confirm(confirmMssg) == true) {
      $.ajax({
        url: photoCommentScriptObj.ajax_url,
        type: "POST",

        data: {
          action: "delete_photo_comment_popup",
          pc_id: pc_id,
          row_index: row_index,
          comment_index: comment_index,
          nonce: photoCommentScriptObj.delete_photo_comment_popup_nonce,
        },
        success: function (response) {
          if (response.data.species_id) {
            var species_id = response.data.species_id;
            localStorage.setItem("triggerInitialClick", "true");
            localStorage.setItem("triggerInitialClickPc", pc_id);
            localStorage.setItem("triggerInitialClickNp", species_id);
            localStorage.setItem("triggerInitialClickRow", row_index);
            // Reload the page
            location.reload();
          }
        },
        error: function (xhr, status, error) {},
      });
    }
  });

  // For closing comment pop-up.
  $(document).on("click", ".comment-message-pop-up-close", function () {
    $(this).closest(".npx-popup-wrapper").remove();
    // $(this).closest('.comment-message-popup-main').remove();
  });

  // For closing comment edit pop-up.
  $(document).on("click", "#cancel_edit_image_comment", function () {
    $(this).closest("#comment-edit-popup").hide();
    $(this).closest("#comment-edit-popup").reset();
  });

  //For the edit drop down show hide
  $(document).on("click", ".comment-edit", function (e) {
    // $(".comment-edit").on("click", function () {
    e.stopPropagation();
    // Close all other .comment-edit-icon elements
    $(".comment-edit-icon")
      .not($(this).siblings(".comment-edit-icon"))
      .css("display", "none");

    var editDropDown = $(this).siblings(".comment-edit-icon");
    // Check the current display property and toggle it
    if (editDropDown.css("display") === "none") {
      editDropDown.css("display", "flex");
    } else {
      editDropDown.css("display", "none");
    }
  });
})(jQuery);
